












import { Component, Vue } from 'vue-property-decorator';
import AuthService from '@/services/AuthService';
import { IAuthUser } from '@/modules/home/models/AuthUser';

const auth = new AuthService();

@Component({
  components: {},
})
export default class Home extends Vue {
  public overlay: boolean = false;
  public currentUser: string = '';
  public accessToken: string = '';
  public accessTokenExpired: boolean | undefined = false;

  get username(): string {
    return this.currentUser;
  }

  public login() {
    auth.login();
  }

  public logout() {
    auth.logout();
  }

  public mounted() {
      auth.login();
  }
}
